<template>
  <div class="an">
    <div class="an_banner"></div>
    <div class="an_chang">
      <div class="an_side">
        <div class="aside_ks aside_kss">
          <p class="rside_title">
            <img src="../../assets/an//department_icon@2x.png" alt />科室
          </p>
          <div class="aside_ks_li" v-for="(item,index) in kminks" :key="index">
            <p class="aside_ks_li_title1">{{item}}</p>
            <p class="aside_ks_li_title2">
              <!-- {{jbinks[index]}} -->
              <span
                v-for="(kitem,kindex) in jbinks[index]"
                :key="kindex"
                :title="kitem.altname"
                @click="goanlist(kitem.altname,kitem.ksname,1)"
              >{{kitem.name}}</span>
            </p>
            <!-- v-show="index == 0" style="display:block;" -->
            <div class="aside_ks_allin">
              <div class="aside_ks_allin_box">
                <div
                  class="aside_ks_allin_li"
                  v-for="(aitem,aindex) in allinks[index]"
                  :key="aindex"
                >
                  <p class="allin_title">
                    <span>{{aitem.name}}</span>
                    <ins></ins>
                  </p>
                  <div
                    class="allin_content"
                    :class="isallinshow[index][aindex] == 2?'allin_content_hiddden':''"
                  >
                    <div class="allin_content_div">
                      <p
                        class="allin_content_p"
                        v-for="(bitem,bindex) in aitem.illnesses"
                        :key="bindex"
                        @click="goanlist(bitem.illness_name,aitem.name,1)"
                      >{{bitem.illness_name}}</p>
                    </div>
                    <div class="dashed"></div>
                    <div
                      v-if="isallinshow[index][aindex] != 3"
                      class="allin_content_hide"
                      :class="isallinshow[index][aindex] == 2?'allin_content_open':''"
                      @click="check_open(index,aindex,1)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 推荐医家 -->
        <div class="aside_ks rside_yj">
          <p class="rside_title">
            <img src="../../assets/an//doctor_icon@2x.png" alt />推荐医家
          </p>
          <div class="aside_ks_li" v-for="(item,index) in jbinyj" :key="index">
            <p class="aside_ks_li_title3">
              {{item}}
              <!-- <span
                v-for="(nitem,nindex) in item"
                :key="nindex"
                @click="goanlist_yj(nitem,2)"
              >{{nitem}}</span>-->
            </p>
            <!-- v-if="index == 0" style="display:block;" -->
            <div class="aside_ks_allin">
              <div class="aside_ks_allin_box">
                <div
                  class="aside_ks_allin_li"
                  v-for="(aitem,aindex) in allinyj[index]"
                  :key="aindex"
                >
                  <p class="allin_title">
                    <span>{{aindex}}</span>
                    <ins></ins>
                  </p>
                  <div
                    class="allin_content"
                    :class="isallinshow_yj[index][aindex] == 2?'allin_content_hiddden':''"
                  >
                    <div class="allin_content_div">
                      <p
                        class="allin_content_p"
                        v-for="(bitem,bindex) in aitem"
                        :key="bindex"
                        @click="goanlist_yj(bitem.doctor,2)"
                      >{{bitem.doctor}}</p>
                    </div>
                    <div class="dashed"></div>
                    <div
                      v-if="isallinshow_yj[index][aindex] != 3"
                      class="allin_content_hide"
                      :class="isallinshow_yj[index][aindex] == 2?'allin_content_open':''"
                      @click="check_open(index,aindex,2)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="aside_ks_li">
            <p class="aside_ks_li_title3">
              <span>更多医家</span>
            </p>
            <!--  style="display:block;" -->
            <div class="aside_ks_allin">
              <div class="aside_ks_allin_box">
                <div class="aside_ks_allin_li" v-for="(aitem,aindex) in doctorArr" :key="aindex">
                  <p class="allin_title">
                    <span>{{aindex}}</span>
                    <ins></ins>
                  </p>
                  <div
                    class="allin_content"
                    :class="isallinshow_qbyj[aindex] == 2?'allin_content_hiddden':''"
                  >
                    <div class="allin_content_div">
                      <p
                        class="allin_content_p"
                        v-for="(bitem,bindex) in aitem"
                        :key="bindex"
                        @click="goanlist_yj(bitem.doctor,2)"
                      >{{bitem.doctor}}</p>
                    </div>
                    <div class="dashed"></div>
                    <div
                      v-if="isallinshow_qbyj[aindex] != 3"
                      class="allin_content_hide"
                      :class="isallinshow_qbyj[aindex] == 2?'allin_content_open':''"
                      @click="check_open(aindex,aindex,3)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="record_cj">
        <p class="record_title">
          <span>常见病</span>找一找是否有你需要
        </p>
        <ul class="rcj_ul">
          <li
            class="rcj_li"
            v-for="(item,index) in illnessesArr"
            :key="index"
            @click="goanlist_yj(item.illness_name,3)"
          >{{item.illness_name}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      illnessesArr: [],
      departmentArr: [],
      departmentsArr: [],
      department_titleArr: [],
      allinks: [],
      isallinshow: [],
      isallinshow_yj: [],
      isallinshow_qbyj: [],
      kminks: [],
      jbinks: [],
      doctorArr: [],
      allinyj: [],
      nameinyj: [],
      jbinyj: []
    };
  },
  created() {
    this.get_chang();
    this.get_doctor();
    this.getside_ks();
  },
  mounted() {
    let that = this;
    // this.$nextTick(function() {
    //   setTimeout(function() {
    //     that.setallinbox();
    //   }, 1000);
    // });
  },
  methods: {
    get_chang() {
      let that = this;
      this.$axios.get("zk_an/illnesses").then(function(res) {
        if (res.data.status_code == 200) {
          //   console.log(res);
          that.illnessesArr = res.data.data;
        }
      });
    },
    // 列表展开切换
    check_open(index, bindex, num) {
      if (num == 1) {
        if (this.isallinshow[index][bindex] == 1) {
          this.$set(this.isallinshow[index], [bindex], 2);
        } else {
          this.$set(this.isallinshow[index], [bindex], 1);
        }
      } else if (num == 2) {
        if (this.isallinshow_yj[index][bindex] == 1) {
          this.$set(this.isallinshow_yj[index], [bindex], 2);
        } else {
          this.$set(this.isallinshow_yj[index], [bindex], 1);
        }
      } else if (num == 3) {
        // isallinshow_qbyj
        if (this.isallinshow_qbyj[index] == 1) {
          this.$set(this.isallinshow_qbyj, [bindex], 2);
        } else {
          this.$set(this.isallinshow_qbyj, [bindex], 1);
        }
      }
    },
    getside_ks() {
      let that = this;
      this.$axios.get("zk_an/departments").then(function(res) {
        if (res.data.status_code == 200) {
          // console.log(res);
          that.departmentArr = res.data.data;
          //   that.departmentsArr = that.listTemp(that.departmentsArr)
          //   that.department_titleArr = that.titleTemp(that.departmentsArr)
          //   that.department_titleArr = that.titleTemp(that.departmentsArr)
          that.allinks = that.listTemp(that.departmentArr);
          that.kminks = that.ktitleTemp(that.departmentArr);
          that.jbinks = that.btitleTemp(that.departmentArr);
          //   console.log(that.departmentsArr)
        }
      });
    },
    get_doctor() {
      let that = this;
      this.$axios.get("zk_an/doctors").then(function(res) {
        // console.log(res);
        if (res.data.status_code == 200) {
          that.doctorArr = res.data.data;
          that.allinyj_showadd(that.doctorArr);
          that.dorctor_listTemp(that.doctorArr);
        }
      });
    },
    goanlist(iname, ksname, num) {
      this.$router.push({
        path: "/anList",
        query: {
          name: iname,
          ks: ksname,
          t: num
        }
      });
    },
    goanlist_yj(iname, num) {
      this.$router.push({
        path: "/anList",
        query: {
          name: iname,
          t: num
        }
      });
    },
    setallinbox(index) {
      // var bheight = $(".aside_ks_allin")[index].offsetHeight;
      // var cheight = $(".inpagetag")[index].offsetHeight;
      // console.log($(".aside_ks_allin"))
      // console.log(
      //   $(".aside_kss .aside_ks_allin .aside_ks_allin_box .aside_ks_allin_li")
      // );
      // if (bheight <= cheight && cheight != 0) {
      //   this.tagmoreArr[index] = true;
      // } else {
      //   this.tagmoreArr[index] = false;
      // }

      // let b = $(".aside_kss .aside_ks_allin .aside_ks_allin_box")
    },
    // 总列表分割
    listTemp(tempArr) {
      let index = 0;
      let count = 3;
      let arrTemp = [];
      let isarrTemp = [];
      let departmentArr = {};
      //   console.log(departmentArr)
      for (let i = 0; i < tempArr.length; i++) {
        index = parseInt(i / count);
        let isArr = tempArr[i];
        let isshow = 1;
        // console.log(isArr)
        if (arrTemp.length <= index) {
          arrTemp.push([]);
          isarrTemp.push([]);
        }
        if (isArr.illnesses.length > 17) {
          isshow = 2;
        } else {
          isshow = 3;
        }
        arrTemp[index].push(tempArr[i]);
        isarrTemp[index].push(isshow);
      }
      this.isallinshow = isarrTemp;
      return arrTemp;
    },
    allinyj_showadd(tempArr) {
      let isshowArr = {};
      for (let i in tempArr) {
        // console.log(i);
        // console.log(tempArr[i].length);
        if (tempArr[i].length > 19) {
          isshowArr[i] = 2;
        } else {
          isshowArr[i] = 3;
        }
      }
      this.isallinshow_qbyj = isshowArr;
      // console.log(isshowArr)
    },
    // 医家分隔
    dorctor_listTemp(tempArr) {
      let index = 0;
      let count = 3;
      let arrTemp = [];

      let anum = [];
      let jindex = 0;
      for (let i in tempArr) {
        anum.push(i);
        // console.log(i)
        jindex++;
        if (jindex >= 9) {
          break;
        }
      }
      let cindex = 0;
      //   isallinshow_yj
      for (let i = 0; i < 3; i++) {
        let newarr = {};
        let titleArr = "";
        let namrArr = [];
        let isshowArr = {};
        // isshowArr.push([])
        for (let j = 0; j < 3; j++) {
          let title = anum[cindex];
          newarr[title] = tempArr[title];
          // console.log(tempArr[title])
          if (tempArr[title].length > 19) {
            isshowArr[title] = 2;
          } else {
            isshowArr[title] = 3;
          }
          if (j == 2) {
            titleArr += tempArr[title][0].doctor
              .replace(/\s*/g, "")
              .replace(/\\n/g, "");
          } else {
            titleArr +=
              tempArr[title][0].doctor.replace(/\s*/g, "").replace(/\\n/g, "") +
              "/";
          }
          cindex++;
        }
        // this.allinyj[i] = newarr
        this.allinyj.push(newarr);
        this.jbinyj.push(titleArr);
        // this.nameinyj.push(namrArr);
        this.isallinshow_yj.push(isshowArr);
      }
      // this.setallinbox()
      // console.log(this.isallinshow_yj);
      // console.log(this.allinyj);
      //   console.log(this.jbinyj);
      //   console.log(this.nameinyj);
      // return arrTemp;
    },
    // 科室名分割
    ktitleTemp(tempArr) {
      let index = 0;
      let count = 3;
      let titleTemp = [];
      let titleArr = [];
      let departmentArr = tempArr;
      for (let i = 0; i < tempArr.length; i++) {
        index = parseInt(i / count);
        if (titleTemp.length <= index) {
          titleTemp.push([]);
        }
        titleTemp[index].push(departmentArr[i].name);
      }
      //   this.department_titleArr = titleTemp
      //   console.log(titleTemp);
      for (let i = 0; i < titleTemp.length; i++) {
        let title = "";
        for (let j = 0; j < titleTemp[i].length; j++) {
          let tarr = titleTemp[i];
          if (tarr.length == 1) {
            title = tarr[0];
          } else {
            if (j == tarr.length - 1) {
              title += tarr[j];
            } else {
              title += tarr[j] + "/";
            }
          }
        }
        // console.log(title)
        titleArr.push(title);
      }
      // console.log(titleArr)
      return titleArr;
    },
    // 科室下病名分割
    btitleTemp(tempArr) {
      let index = 0;
      let count = 3;
      let titleTemp = [];
      let departmentArr = tempArr;
      for (let i = 0; i < tempArr.length; i++) {
        index = parseInt(i / count);
        if (titleTemp.length <= index) {
          titleTemp.push([]);
        }
        titleTemp[index].push({
          name: departmentArr[i].illnesses[0].illness_name.substring(0, 4),
          ksname: departmentArr[i].name,
          altname: departmentArr[i].illnesses[0].illness_name
        });
      }
      //   this.department_titleArr = titleTemp
      // console.log(titleTemp);
      return titleTemp;
    }
  }
};
</script>
<style scoped lang="scss"  type="text/css">
@import "../../assets/style/an/an_index.scss";
</style>